import { useStatsigUser } from "@statsig/react-bindings";
import { type UseStatsigUserResult } from "@statsig/react-bindings/src/useStatsigUser";
import Cookies from "js-cookie";
import { STATSIG_USER_COOKIE_NAME } from "utils/experiments/statsig";

export function useStatsigPersistentUser() {
  const { updateUserAsync, user } = useStatsigUser();

  async function updateStatsigPersistentUser(
    userUpdateArgs: UseStatsigUserResult["updateUserAsync"]["arguments"],
  ) {
    const { customIDs: updatedCustomIDs, ...updatedUser } = userUpdateArgs;
    const { customIDs: originalCustomIDs, ...originalUser } = user;
    const userInfo = {
      ...originalUser,
      ...updatedUser,
      customIDs: {
        ...originalCustomIDs,
        ...updatedCustomIDs,
      },
    };

    const encodedUser = btoa(JSON.stringify(userInfo));
    Cookies.set(STATSIG_USER_COOKIE_NAME, encodedUser, {
      ...(import.meta.env.VITE_BASE_URL && {
        domain: import.meta.env.VITE_BASE_URL,
      }),
      expires: 365,
      path: "/",
    });

    return await updateUserAsync(userUpdateArgs);
  }

  return {
    updateStatsigPersistentUser,
    persistentUser: user,
  };
}
